import React, {Component} from 'react';
import Link from 'gatsby-link';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { FrameContainer as BaseContainerStyles } from '../../styledComponents/layout';
import GoogleIcon from '../Icon/Google';
import Menu from '@material-ui/core/Menu';
import BaseMenuItem from '@material-ui/core/MenuItem';
import { LogoImage } from '../../styledComponents/theme'
const Container = BaseContainerStyles.extend`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1rem;
  padding-bottom: 1rem;
`;

const MenuItem = styled(BaseMenuItem)`
  p {
    border-bottom: solid 1px;
  }

`
const HeaderContainer = styled.header`
  border-bottom: 1px solid #999999;
`;

const LogoContainer = styled.div`
`;


const StyledLink = styled(Link)`
  color: white;
  text-decoration: none;
`;

const StyledGoogleIcon = styled(GoogleIcon)`
  margin-right: 5px;
`;
const ButtonContainer = styled.div`
display:flex;
`;
const MenuButton = styled.img`
  height: 30px;
  margin-left: 20px;
  cursor: pointer;
  @media screen and (max-width: 650px){
    height: 20px;
  }
`;
const MenuButtonWrapper = styled.div`
margin-left: 10px;
`;

const BACKGROUND = 'background-color: #20232a';

class Header extends Component {
  static defaultProps = {
    background: BACKGROUND,
  };

  static propTypes = {
    background: PropTypes.string,
    title: PropTypes.string,
  };

  state = {
    anchorEl: null,
  };
  handleClick = event => {
    this.setState({anchorEl: event.currentTarget});
  };
  handleClose = () => {
    this.setState({anchorEl: null});
  };
  handleItemClick = (url) => {
    this.setState({anchorEl: null});
    location.replace(url);

  };
  render() {
    const {anchorEl} = this.state;
    return(
      <HeaderContainer>
        <Container>
          <LogoContainer>
            <StyledLink to="/"><LogoImage src={"/img/head_logo.png"} alt={"Flick!On!TV"}/></StyledLink>
          </LogoContainer>
          <ButtonContainer>
            <a className="about_btn" href={"/about"}><MenuButton src={"/img/ic_about.png"} alt={"About"}/></a>
            <MenuButton
              src={"/img/ic_search.png"}
              aria-owns={anchorEl ? 'simple-menu' : null}
              aria-haspopup="true"
              onClick={this.handleClick}
              alt={"Search"}
            />
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={this.handleClose}
            >
              <MenuItem onClick={() => this.handleItemClick("/programs")}><p>番組名から探す</p></MenuItem>
              <MenuItem onClick={() => this.handleItemClick("/entertainers")}><p>出演者名から探す</p></MenuItem>
            </Menu>
          </ButtonContainer>
        </Container>
      </HeaderContainer>
    );
  }
}


export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js